'use client';

/** The closing "Grade My Site — Free" key: scrolls back up and puts the cursor in the domain box (same behaviour as the live page). */
export default function ScrollToScan({ children }: { children: React.ReactNode }) {
  return (
    <button
      type="button"
      className="gr-cta"
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        (document.getElementById('gr-domain') as HTMLInputElement | null)?.focus({ preventScroll: true });
      }}
    >
      {children}
    </button>
  );
}
